<template>
  <Drawer
    v-model="innerVisible"
    title="人员信息"
    width="520"
    :mask-closable="true"
    @on-close="close"
  >
    <div v-if="loading" style="padding:40px;text-align:center;">
      <Spin />
    </div>
    <div v-else-if="user" class="ding-ud">
      <div class="ding-ud-head">
        <Avatar v-if="user.avatar" :src="user.avatar" size="64" />
        <Avatar v-else icon="md-person" size="64" />
        <div>
          <h2>{{ user.name || '-' }}</h2>
          <p>{{ user.userid }}</p>
        </div>
      </div>
      <div class="ding-ud-grid">
        <div class="ding-ud-item" v-for="item in fields" :key="item.key">
          <label>{{ item.label }}</label>
          <span v-if="item.key === 'dept_id_list'" class="ding-ud-depts">
            <a
              v-for="id in deptIds"
              :key="id"
              class="ding-ud-link"
              @click="$emit('open-dept', id)"
            >{{ deptLabel(id) }}</a>
            <span v-if="!deptIds.length">-</span>
          </span>
          <a
            v-else-if="item.key === 'manager_userid' && user.manager_userid"
            class="ding-ud-link"
            @click="$emit('open-user', user.manager_userid)"
          >{{ userLabel(user.manager_userid) }}</a>
          <span v-else>{{ displayValue(item.key) }}</span>
        </div>
      </div>
      <div class="ding-ud-foot">
        <Button type="primary" @click="$emit('edit', user)" v-if="showEdit">编辑</Button>
        <Button style="margin-left:8px;" @click="close">关闭</Button>
      </div>
    </div>
    <BaseEmpty v-else msg="未找到人员信息" />
  </Drawer>
</template>

<script>
import {
  ensureDingDirectory,
  formatUserLabel,
  getDeptName,
} from './ding-directory';

export default {
  name: 'DingUserDrawer',
  routerOption: {
    as_child: false,
  },
  props: {
    value: {type: Boolean, default: false},
    userid: {type: String, default: ''},
    showEdit: {type: Boolean, default: false},
  },
  data() {
    return {
      loading: false,
      user: null,
      fields: [
        {label: 'userid', key: 'userid'},
        {label: '手机号', key: 'mobile'},
        {label: '职位', key: 'title'},
        {label: '工号', key: 'job_number'},
        {label: '邮箱', key: 'email'},
        {label: '分机号', key: 'telephone'},
        {label: '办公地点', key: 'work_place'},
        {label: '部门', key: 'dept_id_list'},
        {label: '直属主管', key: 'manager_userid'},
        {label: '备注', key: 'remark'},
      ],
    };
  },
  computed: {
    innerVisible: {
      get() { return this.value; },
      set(v) { this.$emit('input', v); },
    },
    deptIds() {
      const list = (this.user && this.user.dept_id_list) || [];
      return Array.isArray(list) ? list : [];
    },
  },
  watch: {
    value(v) {
      if (v && this.userid) this.load();
    },
    userid(v) {
      if (this.value && v) this.load();
    },
  },
  methods: {
    unwrap(res) {
      return (res && res.data && res.data.data) || (res && res.data) || {};
    },
    deptLabel(id) {
      return getDeptName(id) || String(id);
    },
    userLabel(id) {
      return formatUserLabel(id);
    },
    displayValue(key) {
      if (!this.user) return '-';
      const val = this.user[key];
      if (val == null || val === '') return '-';
      if (typeof val === 'object') {
        try { return JSON.stringify(val); } catch (e) { return String(val); }
      }
      return String(val);
    },
    close() {
      this.innerVisible = false;
    },
    async load() {
      if (!this.userid) return;
      this.loading = true;
      this.user = null;
      try {
        await ensureDingDirectory(this.$api);
        const res = await this.$api.get(`/ding/users/${encodeURIComponent(this.userid)}`);
        const data = this.unwrap(res);
        this.user = data && (data.userid || data.name) ? data : null;
        if (!this.user) {
          // 回退缓存
          const cached = (await ensureDingDirectory(this.$api)).userMap[String(this.userid)];
          this.user = cached || {userid: this.userid, name: ''};
        }
      } catch (e) {
        try {
          const cached = (await ensureDingDirectory(this.$api)).userMap[String(this.userid)];
          this.user = cached || {userid: this.userid, name: ''};
        } catch (e2) {
          this.user = {userid: this.userid, name: ''};
        }
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.ding-ud-head {
  display: flex;
  align-items: center;
  gap: 16px;
  padding-bottom: 16px;
  margin-bottom: 16px;
  border-bottom: 1px solid var(--border);
  h2 {
    margin: 0 0 4px;
    font-size: 18px;
  }
  p {
    margin: 0;
    color: var(--text2);
    font-size: 13px;
  }
}
.ding-ud-grid {
  display: grid;
  gap: 12px;
}
.ding-ud-item {
  display: flex;
  align-items: flex-start;
  label {
    width: 90px;
    color: var(--text2);
    flex-shrink: 0;
  }
  span {
    word-break: break-all;
  }
}
.ding-ud-depts {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.ding-ud-link {
  color: var(--primary);
  cursor: pointer;
  margin-right: 4px;
}
.ding-ud-foot {
  margin-top: 24px;
  text-align: right;
}
</style>
